import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
}

interface IBranchIncentive {
    salesBranchPercentage: number | null,
    recruiterBranchPercentage?: number | null
}

const percentages = [
    { name: "--SELECT--", value: null },
    { name: "0", value: 0 },
    { name: "15", value: 15 },
    { name: "35", value: 35 },
    { name: "50", value: 50 },
    { name: "70", value: 70 },
    { name: "100", value: 100 },
];

const schema = yup.object({
    salesBranchPercentage: yup.number().required("Sales Branch % is required"),
    recruiterBranchPercentage: yup.number().nullable(),
});

export const BranchIncentiveCalculation = (props: Iprops) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [showRecPer, setShowRecPer] = useState<boolean>(false);
    const [whatToDo, setWhatToDo] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, watch, setError, clearErrors, setValue } = useForm<IBranchIncentive>({
        resolver: yupResolver(schema),
        defaultValues: { salesBranchPercentage: 0, recruiterBranchPercentage: 0 },
        shouldFocusError: false
    });

    const updateBranchPercentage = async (data: IBranchIncentive) => {
        setLoading(true);
        const method = "PUT";
        const message = (props.po.salesBranchPercentage != null && props.po.salesBranchPercentage != undefined && props.po.salesBranchPercentage > 0) ? "Updated Successfully" : "Added Successfully";
        const newData = { ...data, pO_ID: props.po.pO_ID };
        const response = await Fetch("vwPODetails/branchIncentive", method, newData, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: message });
            setLoading(false);
        } else setLoading(false);
    }

    const onSubmit = (data: IBranchIncentive) => {
        if ((Number(data.recruiterBranchPercentage || "0") + Number(data.salesBranchPercentage || "0")) > 100) {
            props.toast.current.show({ severity: 'error', detail: `Percentage must be less or equal to 100`, life: 3000 });
        } else {
            confirmDialog({
                message: <p>Are you sure you want to save these branch percentage for Branch incentive for this PO</p>,
                // header: 'Confirm Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptClassName: 'p-button-success',
                accept: () => updateBranchPercentage(data),
                reject: () => { }
            });
        }
    }

    useEffect(() => {
        reset({ salesBranchPercentage: props.po.salesBranchPercentage, recruiterBranchPercentage: props.po.recruiterBranchPercentage });
        if (props.po.salesBranchID !== props.po.recruiterBranchID) {
            setShowRecPer(true);
        }

        if (props.po.salesBranchPercentage === null && props.po.recruiterBranchPercentage === null) {
            setWhatToDo(true);


            const noidaBranch: number[] = [1, 6, 7, 13, 18, 24, 29];
            const agraBranch: number[] = [3, 9, 12, 22, 23, 30, 32, 33];
            const varanasiBranch: number[] = [4, 10, 21, 25, 31];
            const ranchiBranch: number[] = [11, 17, 26];
            const bhubaneswarBranch: number[] = [5, 8, 16, 19, 28];

            const BranchIDs70: number[] = [7, 8, 9, 10, 11, 13, 14];
            const poCompany = { Company_ID: props.po.company_ID_Sales || 0 };

            const SalesBranch = { Company_ID: props.po.company_ID_Sales || 0, Branch_ID: props.po.salesBranchID || 0, BranchName: props.po.salesBranch || "" };
            const RecruitersBranch = { Company_ID: props.po.company_ID_Recruiter || 0, Branch_ID: props.po.recruiterBranchID || 0, BranchName: props.po.recruiterBranch || "" };

            let BranchIDs: number[] = [];

            let maxPer: number = 100;

            if (poCompany != null && poCompany.Company_ID == 1) // TEK Inspirations LLC
            {
                BranchIDs = noidaBranch;
            }

            if (poCompany != null && poCompany.Company_ID == 2) // Vyze INC
            {
                BranchIDs = [...noidaBranch, ...bhubaneswarBranch];
            }

            if (poCompany != null && poCompany.Company_ID == 3) // GVR Infotek
            {
                BranchIDs = noidaBranch;
            }

            if (poCompany != null && poCompany.Company_ID == 4) // Adventa Tech Inc
            {
                BranchIDs = [...noidaBranch, ...bhubaneswarBranch];
            }

            if (poCompany != null && poCompany.Company_ID == 5) // TekIT Pro
            {
                BranchIDs = noidaBranch;
            }

            if (poCompany != null && poCompany.Company_ID == 6) // Vyze2 INC
            {

            }

            if (poCompany != null && poCompany.Company_ID == 7) // Vizon Inc
            {
                BranchIDs = agraBranch;
                maxPer = 70;
            }

            if (poCompany != null && poCompany.Company_ID == 8) // Jobvritta Inc
            {
                BranchIDs = varanasiBranch;
                maxPer = 70;
            }

            if (poCompany != null && poCompany.Company_ID == 9) // Talent_Aura Inc
            {
                BranchIDs = ranchiBranch;
                maxPer = 70;
            }

            if (poCompany != null && poCompany.Company_ID == 10) // Next Orbits Inc
            {
                BranchIDs = noidaBranch;
                maxPer = 70;
            }

            if (poCompany != null && poCompany.Company_ID == 11) // Corehunt Inc
            {
                BranchIDs = agraBranch;
                maxPer = 70;
            }

            if (poCompany != null && poCompany.Company_ID == 12) // Infoserv LLC
            {
                BranchIDs = varanasiBranch;
            }

            if (poCompany != null && poCompany.Company_ID == 13) // Technovion LLC
            {
                BranchIDs = agraBranch;
                maxPer = 70;
            }

            if (poCompany != null && poCompany.Company_ID == 14) // Talent_Portus Inc
            {
                BranchIDs = agraBranch;
                maxPer = 70;
            }

            if (BranchIDs.includes(SalesBranch.Branch_ID) && BranchIDs.includes(RecruitersBranch.Branch_ID)) {
                if (SalesBranch.Company_ID == RecruitersBranch.Company_ID && BranchIDs70.includes(SalesBranch.Company_ID ?? 0)) {
                    // Sales - 70%
                    setValue("salesBranchPercentage", 70);
                }
                else if (SalesBranch.Company_ID == RecruitersBranch.Company_ID && !BranchIDs70.includes(SalesBranch.Company_ID ?? 0)) {
                    if (SalesBranch.BranchName.toLowerCase().trim() == RecruitersBranch.BranchName.toLowerCase().trim()) {
                        // Sales - 100%
                        setValue("salesBranchPercentage", 100);
                    }
                    else {
                        // Sales - 50%
                        // Recruiter - 50%
                        setValue("salesBranchPercentage", 50);
                        setValue("recruiterBranchPercentage", 50);
                    }
                }
                else {
                    // Sales - 50%
                    // Recruiter - 50%
                    setValue("salesBranchPercentage", 50);
                    setValue("recruiterBranchPercentage", 50);
                }
            }
            else if (BranchIDs.includes(SalesBranch.Branch_ID) && !BranchIDs.includes(RecruitersBranch.Branch_ID)) {
                // Sales - 50%
                // Recruiter 35% but - 50%
                setValue("salesBranchPercentage", 50);
                setValue("recruiterBranchPercentage", 50);
            }
            else if (!BranchIDs.includes(SalesBranch.Branch_ID) && BranchIDs.includes(RecruitersBranch.Branch_ID)) {
                // Sales 35% But - 50%
                // Recruiter - 50%
                setValue("salesBranchPercentage", 50);
                setValue("recruiterBranchPercentage", 50);
            }
            else {
                if (SalesBranch.Company_ID == RecruitersBranch.Company_ID && SalesBranch.BranchName.toLowerCase().trim() == RecruitersBranch.BranchName.toLowerCase().trim()) {
                    // Sales - 70%
                    setValue("salesBranchPercentage", 70);
                } else {
                    // Sales - 35%
                    // Recruiter - 35%
                    setValue("salesBranchPercentage", 35);
                    setValue("recruiterBranchPercentage", 35);
                }
            }
        }


    }, [props.po]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDropdown required column={3} label={"Sales Company: " + props?.po?.company_Name_Sales + " & Branch: " + props?.po?.salesBranch + " %"} control={control} name="salesBranchPercentage" options={percentages} optionLabel="name" optionValue="value" placeholder="Select Percentage" error={errors.salesBranchPercentage?.message} />
                {showRecPer && <JVDropdown required column={3} label={"Recruiter Company:  " + props?.po?.company_Name_Recruiter + " & Branch: " + props?.po?.recruiterBranch + " %"} control={control} name="recruiterBranchPercentage" options={percentages} optionLabel="name" optionValue="value" placeholder="Select Percentage" error={errors.recruiterBranchPercentage?.message} />}
                <div className="field col-12 md:col-3">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label={whatToDo ? "Add %" : "Update %"}></Button>
                </div>
            </form>
            <ConfirmDialog />
        </>
    );
}